import { onError } from "@apollo/client/link/error";
import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/react-hooks";
import { fetchAuthSession } from "aws-amplify/auth";
import { AUTH_TYPE, AuthOptions, createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { isEmpty } from "lodash";

import { ErrorContext } from "../context/error";

const url = process.env.REACT_APP_APPSYNC_GRAPHQL_API_URI || "";
const region = process.env.REACT_APP_AWS_REGION || "";

const getAuth = async () => {
  const session = await fetchAuthSession();
  const iamToken = session.credentials;

  return {
    accessKeyId: iamToken?.accessKeyId || "",
    secretAccessKey: iamToken?.secretAccessKey || "",
    sessionToken: iamToken?.sessionToken || "",
  };
};

const auth: AuthOptions = {
  type: AUTH_TYPE.AWS_IAM,
  credentials: getAuth,
};

export const createApolloClient = (errorHandler: (error: ErrorContext) => void) => {
  const errorHandlerLink = onError(({ graphQLErrors, networkError }) => {
    let errorMessages: string[] = [];

    if (networkError) {
      errorMessages.push(networkError.message);
    }

    if (graphQLErrors) {
      const graphQLErrorMessages = graphQLErrors.map(
        ({ message, locations, path }) => `${message}: ${JSON.stringify({ locations, path }, null, 2)}`,
      );

      errorMessages = [...errorMessages, ...graphQLErrorMessages];
    }

    if (!isEmpty(errorMessages)) {
      errorHandler({ errorMessages });
    }
  });

  const link = ApolloLink.from([
    errorHandlerLink,
    createAuthLink({ url, region, auth }),
    createSubscriptionHandshakeLink(url),
  ]);

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};
